import Component from '@glimmer/component';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { and } from '@ember/object/computed';

export default class LocationMapComponent extends Component {
  @and('args.latitude', 'args.longitude') hasCoordinates;
}
